var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.noteTypeComponent,{tag:"component",attrs:{"noteId":_vm.noteId},on:{"close":_vm.close}})}
var staticRenderFns = []

export { render, staticRenderFns }